/** Keep framework-specific theme integration out of the application theme contract. */
export function applyFrameworkTheme(light: boolean): void {
    document.body.setAttribute("data-bs-theme", light ? "light" : "dark");
}
